import moment from 'moment'

import { SerializableFilterGroup,TransformedFilterGroup } from 'api'
import { FilterableEntity, FilterGroup,filterMap } from 'context/filtersContext'

export const transformFiltersToBackend = (
  filterGroups: FilterGroup[]
): SerializableFilterGroup[] => {
  const filterGroupsWithValues = filterGroups
    .map(group => group.filter(filter => filter.values !== undefined && filter.values !== null))
    .filter(group => group.length > 0)

  return filterGroupsWithValues
    .map(filters => {
      const find = (type: FilterableEntity) => filters?.find(item => item.filterType === type)

      const accountOwners = find(FilterableEntity.ACCOUNT_OWNERS)
      const selectedActivities = find(FilterableEntity.ACTIVITIES)?.values
      const selectedContactType = find(FilterableEntity.CONTACT_TYPES)?.values
      const targetedOnly = find(FilterableEntity.TARGETED)?.values
      const selectedContactRole = find(FilterableEntity.CONTACT_ROLE)
      const selectedPageUrls = find(FilterableEntity.PAGE_URL)

      return {
        accountOwners: filterMap[FilterableEntity.ACCOUNT_OWNERS].transformFilterForApi(
          accountOwners
        ),

        selectedActivities: filterMap[FilterableEntity.ACTIVITIES].transformFilterForApi(
          selectedActivities
        ),

        selectedContactType: filterMap[FilterableEntity.CONTACT_TYPES].transformFilterForApi(
          selectedContactType
        ),

        targetedOnly: filterMap[FilterableEntity.TARGETED].transformFilterForApi(targetedOnly),

        selectedContactRole: filterMap[FilterableEntity.CONTACT_ROLE].transformFilterForApi(
          selectedContactRole
        ),

        selectedPageUrls: filterMap[FilterableEntity.PAGE_URL].transformFilterForApi(
          selectedPageUrls
        ),

        attributeFilters: (() => {
          const customFilters = filters
            .filter(f => f.filterSubtype !== undefined)
            .filter(f => f.values !== null && f.values !== undefined && f.values.length !== 0)

          if (customFilters.length === 0) {
            return undefined
          }

          return customFilters.map(filter => ({
            filterOperation: filter.operator,
            attribute: filter.filterSubtype,
            comparisonType: filter.valueType,
            values: (() => {
              if (filter.values?.startDate || moment.isMoment(filter.values)) {
                return filterMap[FilterableEntity.DATE_RANGE].transformFilterForApi(filter)
              }

              if (filter.attributeType === 'NUMBER') {
                return filterMap[FilterableEntity.NUMBER].transformFilterForApi(filter)
              }

              if (Array.isArray(filter.values)) {
                return filter?.values.map(({ value }: any) => value?.trim())
              } else {
                return [filter.values]
              }
            })()
          }))
        })()
      }
    })
    .filter(group => Object.values(group).some(Boolean))
    .map(
      ({
        accountOwners,
        selectedActivities,
        attributeFilters,
        selectedContactType,
        selectedContactRole,
        targetedOnly,
        selectedPageUrls
      }: TransformedFilterGroup) => ({
        accountOwnerFilter: accountOwners,
        activityTypes: selectedActivities,
        attributeFilters,
        contactFilterType: selectedContactType,
        contactRoleFilter: selectedContactRole,
        targetedOnly,
        contexts: selectedPageUrls
      })
    )
}
